/* @flow weak */
import React from 'react';
import LinkedAccountsTableRow from './LinkedAccountsTableRow.jsx';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';

import './styles/LinkedAccountsTable.scss';

type Props = {
  bankAccounts: ConnectedBankAccount[],
};

function LinkedAccountsTable(props: Props) {
  return (
    <table className="LinkedAccountsTable">
      <thead>
        <tr>
          <th>Name</th>
          <th>Bank account</th>
        </tr>
      </thead>
      <tbody>
        {props.bankAccounts.map((bankAccount) => {
          if (!bankAccount.isApproved()) {
            return null;
          }

          return <LinkedAccountsTableRow key={bankAccount.id} bankAccount={bankAccount} />;
        })}
      </tbody>
    </table>
  );
}

export default LinkedAccountsTable;



// WEBPACK FOOTER //
// ./src/payments/components/LinkedAccountsTable.jsx